import SupplierSettings from './SupplierSettings';

export default SupplierSettings;
